import { pdf } from '@react-pdf/renderer';
import InvoicePDF from './InvoicePDF';

export const savePDF = async (invoiceData, fileName = 'invoice.pdf') => {
  try {
    const blob = await pdf(<InvoicePDF invoiceData={invoiceData} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

// Alternative method using jsPDF (if you want more control)
export const generatePDFWithJSPDF = (invoiceData) => {
  // This is a simplified version - you'd need to implement the actual PDF generation
  const { jsPDF } = require('jspdf');
  const doc = new jsPDF();
  
  // Add content to PDF based on your template
  doc.text(`# INVOICE`, 20, 20);
  doc.text(`Invoice number: ${invoiceData.invoiceNumber}`, 20, 30);
  // ... add more content
  
  doc.save('invoice.pdf');
};